import {
  ActionTypes,
  FetchUserFailAction,
  FetchUserStartAction,
  FetchUserSuccessAction,
  cleanUserAction,
} from './types';

import { User } from '@/types/legacyUser';

const fetchUserSuccess = (payload: User): FetchUserSuccessAction => ({
  type: ActionTypes.FETCH_USER_SUCCESS,
  payload,
});
const cleanUser = (): cleanUserAction => ({
  type: ActionTypes.CLEAN_USER,
});
const fetchUserStart = (): FetchUserStartAction => ({
  type: ActionTypes.FETCH_USER_START,
});

const fetchUserFail = (payload: string): FetchUserFailAction => ({
  type: ActionTypes.FETCH_USER_FAIL,
  payload,
});

export { fetchUserSuccess, fetchUserStart, fetchUserFail, cleanUser };
